import { useQuery } from '@tanstack/react-query';
import { get } from '../../api/client';

const Keys = {
  STUDENTS_DEMOGRAPHY: 'STUDENTS_DEMOGRAPHY',
};
export const useStudentsDemographyHook = () =>
  useQuery([Keys.STUDENTS_DEMOGRAPHY], () =>
    get({ url: `api/v1/admin/student-demography` })
  );
